import axios from "axios";

const endpoint_url = "/message/options/audienceGroups";

const getAudienceGroup = () => {
  return new Promise((resolve, reject) => {
    axios
      .get(endpoint_url)
      .then((response) => resolve(response))
      .catch((error) => {
        return reject(error.response);
      });
  });
};

export default getAudienceGroup;
